import { motion } from "framer-motion";
import { PARTNER_STRIP, partners } from "@/data/partners";

export default function PartnerStrip() {
  return (
    <section className="partner-strip" data-testid="partner-strip">
      <div className="tw-container mb-8 sm:mb-10 text-center max-w-3xl mx-auto">
        <div className="overline">{PARTNER_STRIP.overline}</div>
        <h2 className="mt-3 tw-heading-section text-2xl sm:text-3xl md:text-4xl">
          {PARTNER_STRIP.title.split(" ").slice(0, -2).join(" ")}{" "}
          <span className="blue-text font-display italic">
            {PARTNER_STRIP.title.split(" ").slice(-2).join(" ")}
          </span>
        </h2>
        <p className="mt-4 text-[#b8c9e4] text-sm sm:text-base leading-relaxed px-2 sm:px-0">
          {PARTNER_STRIP.lead}
        </p>
      </div>

      <div className="tw-container">
        <div className="partner-logos" role="list" aria-label="Partneri — profesionalna hemija">
          {partners.map((partner, i) => (
            <motion.div
              key={partner.id}
              role="listitem"
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06 }}
              className="partner-logo"
              title={`${partner.name} — ${partner.role}`}
            >
              <img
                src={partner.logo}
                alt={`${partner.name} — ${partner.role}`}
                className="partner-logo__img"
                loading="lazy"
                width={160}
                height={40}
              />
              <span className="partner-logo__role">{partner.role}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
